import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SplitterModule } from 'primeng/splitter';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { BuscaClientesComponent } from './busca-clientes/busca-clientes.component';
import { EditorCodigoComponent } from './editor-codigo/editor-codigo.component';
import { EditorDiffComponent } from './editor-codigo/editor-diff.component';
import { FonteSqlComponent } from './fonte/fonte-sql.component';
import { ConversaIaComponent } from './ia/conversa-ia.component';
import { CriarIaComponent } from './ia/criar-ia.component';
import { RelatoriosDinamicosComponent } from './lista/relatorios-dinamicos.component';
import { ModeloEditorComponent } from './modelo/modelo-editor.component';
import { ResultadoRelatorioComponent } from './resultado/resultado-relatorio.component';
import { SeletorBaseComponent } from './seletor-base/seletor-base.component';

@NgModule({
  declarations: [
    RelatoriosDinamicosComponent,
    FonteSqlComponent,
    ModeloEditorComponent,
    ResultadoRelatorioComponent,
    EditorCodigoComponent,
    EditorDiffComponent,
    SeletorBaseComponent,
    BuscaClientesComponent,
    ConversaIaComponent,
    CriarIaComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    AccordionModule,
    AutoCompleteModule,
    ButtonModule,
    ChartModule,
    CheckboxModule,
    ChipsModule,
    ConfirmDialogModule,
    DialogModule,
    DropdownModule,
    InputNumberModule,
    InputTextModule,
    InputTextareaModule,
    MultiSelectModule,
    ProgressBarModule,
    SelectButtonModule,
    SidebarModule,
    SplitterModule,
    TableModule,
    TabViewModule,
    ToastModule,
    TooltipModule,
    TreeModule,
    TreeTableModule,
  ],
})
export class RelatorioDinamicoModule {}
